import { createFileRoute, redirect } from '@tanstack/react-router';

// relative imports
import LoadingPage from '../../../components/shared/page-components/LoadingPage';
import IntegrationPageContainer from '../../../components/subledger-integrations/IntegrationPageContainer';

type IntegrationId = 'xero' | 'qbo';

export const Route = createFileRoute(
  '/_authenticated/integrations/$integrationId',
)({
  component: IntegrationPageContainer,
  params: {
    parse: (rawParams) => {
      const integrationId = rawParams.integrationId as IntegrationId;
      return { integrationId };
    },
  },
  beforeLoad: async ({ params }) => {
    const { integrationId } = params;
    if (!['xero', 'qbo'].includes(integrationId)) {
      throw redirect({
        to: '/integrations',
        replace: true,
      });
    }
  },
  pendingComponent: () => <LoadingPage loadingPage />,
});
